import { ModuleSkillModelConfig } from './models/module/ModuleSkill';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';

import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';
import axios from 'axios';
import moment from 'moment';
import { Alert } from './helpers/alert.js';
import { routes } from './helpers/routes';
import ReadMore from 'vue-read-more';
import VueMasonry from 'vue-masonry-css';
import VueLazyLoad from 'vue-lazyload';
import LightBox from 'vue-image-lightbox';
import VueNestable from 'vue-nestable';
import VueMoment from 'vue-moment';
import 'moment/locale/nl';
import OrgChart from './packages/orgchart/orgchart';
import VueShepherd from 'vue-shepherd';
import { TourController } from './classes/wizard/TourController';
import JsonExcel from 'vue-json-excel';
import * as Sentry from '@sentry/vue';
import { Common } from './helpers/common.js';
import VueI18n from 'vue-i18n';
import en from '../../../lang/en.json';
import nl from '../../../lang/nl.json';

import { ClientTable, ServerTable } from 'vue-tables-2';
import VueSignaturePad from 'vue-signature-pad';
import VueApexCharts from 'vue-apexcharts';
import datePicker from 'vue-bootstrap-datetimepicker';
import { AuthUser } from './classes/auth/AuthUser';

import { Ords } from 'ords/dist';
import { AssignmentModelConfig } from './models/assignment/Assignment';
import { AssignmentPublishingModelConfig } from './models/assignment/AssignmentPublishing';
import { AssignmentDeadlineModelConfig } from './models/assignment/AssignmentDeadline';
import { SubAssignmentModelConfig } from './models/assignment/sub-assignment/SubAssignment';
import { SubAssignmentDeadlineModelConfig } from './models/assignment/sub-assignment/SubAssignmentDeadline';
import { AssignmentPartModelConfig } from './models/assignment/sub-assignment/part/AssignmentPart';
import { AssignmentPartTextModelConfig } from './models/assignment/sub-assignment/part/AssignmentPartText';
import { AssignmentPartVideoLinkModelConfig } from './models/assignment/sub-assignment/part/AssignmentPartVideoLink';
import { AssignmentPartFileModelConfig } from './models/assignment/sub-assignment/part/AssignmentPartFile';
import { AssignmentPartListItemModelConfig } from './models/assignment/sub-assignment/part/AssignmentPartListItem';
import { AssignmentPartListOptionModelConfig } from './models/assignment/sub-assignment/part/AssignmentPartListOption';
import { PortfolioRatingModelConfig } from './models/portfolio/PortfolioRating';
import { AssignmentStatusModelConfig } from './models/assignment/AssignmentStatus';
import { SubAssignmentStatusModelConfig } from './models/assignment/sub-assignment/SubAssignmentStatus';
import { AssignmentFeedbackModelConfig } from './models/assignment/AssignmentFeedback';
import { ProfileImageModelConfig } from './models/ProfileImage';
import { SubAssignmentFeedbackModelConfig } from './models/assignment/sub-assignment/subAssignmentFeedback';
import { AssignmentPartAnswerModelConfig } from './models/assignment/sub-assignment/part/answer/AssignmentPartAnswer';
import { AssignmentPartAnswerTextModelConfig } from './models/assignment/sub-assignment/part/answer/AssignmentPartAnswerText';
import { AssignmentPartAnswerJsonModelConfig } from './models/assignment/sub-assignment/part/answer/AssignmentPartAnswerJson';
import {
    AssignmentPartAnswerFileModelConfig
} from './models/assignment/sub-assignment/part/answer/AssignmentPartAnswerFile';
import {
    AssignmentPartAnswerListItemModelConfig
} from './models/assignment/sub-assignment/part/answer/AssignmentPartAnswerListItem';
import { PortfolioRatingResultModelConfig } from './models/portfolio/PortfolioRatingResult';
import { AssignmentPageModelConfig } from './models/assignment/sub-assignment/AssignmentPage';
import {
    AssignmentPartAnswerListCheckModelConfig
} from './models/assignment/sub-assignment/part/answer/AssignmentPartAnswerListCheck';
import { UserModelConfig } from './models/User';
import { LasStudentModelConfig } from './models/las/LasStudent';
import { PersonalGoalsModelConfig } from './models/personalgoals/PersonalGoals';
import { PersonalGoalsTaskModelConfig } from './models/personalgoals/PersonalGoalsTask';
import { PersonalGoalsBadgeModelConfig } from './models/personalgoals/PersonalGoalsBadge';
import { PersonalGoalsSkillModelConfig } from './models/personalgoals/PersonalGoalsSkill';
import { PersonalGoalTaskFileModelConfig } from './models/personalgoals/PersonalGoalTaskFile';
import InlineSvgPlugin from 'vue-inline-svg';
import { StudentsModelConfig } from './models/students/Students';
import { TeachersModelConfig } from './models/teachers/Teachers';
import { GroupModelConfig } from './models/groups/Group';
import { CourseModelConfig } from './models/course/Course';
import { GroupPairGroupsConfig } from './models/group-pair/GroupPairGroups';
import { GroupPairGroupTeachersConfig } from './models/group-pair/GroupPairGroupTeachers';
import { GroupPairStudentsConfig } from './models/group-pair/GroupPairStudents';
import { GroupPairGroupCoursesConfig } from './models/group-pair/GroupPairGroupCourses';
import { GroupPairTeachersConfig } from './models/group-pair/GroupPairTeachers';
import { SkillModelConfig } from './models/skill/Skill';
import { SkillTreeModelConfig } from './models/skill/SkillTree';
import { SkillSkillTreeModelConfig } from './models/skill/SkillSkillTree';
import { RubricModelConfig } from './models/rubric/Rubric';
import { RubricAnswerConfig } from './models/rubric/RubricAnswer';
import { RubricCellConfig } from './models/rubric/RubricCell';
import { RubricColumnConfig } from './models/rubric/RubricColumn';
import { RubricFormConfig } from './models/rubric/RubricForm';
import { RubricOptionConfig } from './models/rubric/RubricOption';
import { RubricRowConfig } from './models/rubric/RubricRow';
import { RubricSectionConfig } from './models/rubric/RubricSection';
import { RubricableSkillLevelYearModelConfig } from './models/rubric/RubricableSkillLevelYear';
import { ModuleModelConfig } from './models/module/Module';
import { FileModelConfig } from './models/file/File';
import { ImageModelConfig } from './models/image/Image';
import { ModuleUserModelConfig } from './models/module/ModuleUser';
import { ModulePeriodModelConfig } from './models/module/ModulePeriod';
import { PeriodModelConfig } from './models/module/Period';
import { ModuleDateModelConfig } from './models/module/ModuleDate';
import { ModuleTagsModelConfig } from './models/module/ModuleTags';
import { ModuleModuleTagsModelConfig } from './models/module/ModuleModuleTags';
import { ModuleTagModelConfig } from './models/module/ModuleTag';
import { ModuleSkillTreeModelConfig } from './models/module/ModuleSkillTree';
import { ModuleSchoolEducationLevelModelConfig } from './models/module/ModuleSchoolEducationLevel';
import { ModuleTeachersodelConfig } from './models/module/ModuleTeachers';
import { RubricSurveyConfig } from './models/rubric/survey/RubricSurvey';
import { RubricSurveyUserConfig } from './models/rubric/survey/RubricSurveyUser';
import { RubricSurveyUserPeerConfig } from './models/rubric/survey/RubricSurveyUserPeer';
import { RubricFormResultConfig } from './models/rubric/rubricFormResult';
import { DefaultSkillTreesModelConfig } from './models/skill/DefaultSkillTrees';
import { Skill_TreeModelConfig } from './models/skill/Skill_Tree';
import { LasGroupsModelConfig } from './models/las/LasGroups';
import { LasMainGroupsModelConfig } from './models/las/LasMainGroups';
import { groupsModelConfig } from './models/group/Groups';
import { projectModelConfig } from './models/projects/Project';
import { AssignmentCooperationModelConfig } from './models/assignment/AssignmentCooperation';
import { AssignmentPartnerModelConfig } from './models/assignment/AssignmentPartner';
import { AssignmentPartnerUserModelConfig } from './models/assignment/assignmentPartnerUser';
import { SchoolTypeModelConfig } from './models/school/SchoolType';
import { SchoolModelConfig } from './models/school/School';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import { RatingModelConfig } from './models/rating/Rating';
import { RatingSectionModelConfig } from './models/rating/RatingSection';
import { RatingItemModelConfig } from './models/rating/RatingItem';
import { RatingItemOptionModelConfig } from './models/rating/RatingItemOption';
import { AgendaItemModelConfig } from './models/agenda/AgendaItem';
import { PersonalGoalTaskDeadlineModelConfig } from './models/personalgoals/PersonalGoalTaskDeadline';
import { EducationLevelModelConfig } from './models/EducationLevel';
import { QuestionnaireModelConfig } from './models/questionnaire/Questionnaire';
import { QuestionnaireSectionModelConfig } from './models/questionnaire/QuestionnaireSections';
import { QuestionnaireQuestionModelConfig } from './models/questionnaire/QuestionnaireQuestion';
import { RoadmapModelConfig } from './models/roadmap/Roadmap';
import { RoadmapStepModelConfig } from './models/roadmap/RoadmapStep';
import { DeadlineModelConfig } from './models/Deadline';
import { RoleModelConfig } from './models/Role';
import { AssignmentStatusLogModelConfig } from './models/assignment/AssignmentStatusLog';
import { AssignmentStatusActivityModelConfig } from './models/assignment/AssignmentStatusActivity';
import { SubAssignmentStatusActivityModelConfig } from './models/assignment/sub-assignment/SubAssignmentStatusActivity';
import { SubAssignmentStatusLogModelConfig } from './models/assignment/sub-assignment/SubAssignmentStatusLog';
import { ProfileCategoryModelConfig } from './models/profile/ProfileCategory';
import { CustomFormModelConfig } from './models/custom-form/CustomForm';
import { CustomFormPageModelConfig } from './models/custom-form/CustomFormPage';
import { CustomFormQuestionModelConfig } from './models/custom-form/CustomFormQuestion';
import { CustomFormQuestionOptionModelConfig } from './models/custom-form/CustomFormQuestionOption';
import { AfaqCategoryModelConfig } from './models/afaq/AfaqCategory';
import { AfaqQuestionAnswerModelConfig } from './models/afaq/AfaqQuestionAnswer';
import { AfaqTagModelConfig } from './models/afaq/AfaqTag';
import { InternshipDurationTagModelConfig } from './models/internship/InternshipDurationTag';
import { InternshipModelConfig } from './models/internship/Internship';
import { InternshipTagModelConfig } from './models/internship/InternshipTag';
import { BadgesModelConfig } from './models/badges/Badges';
import { LaravelFormatter } from './internationalization/LaravelFormatter';

require('./bootstrap');

Vue.use(VueSignaturePad);

Vue.use(VueI18n);

// Get locale from HTML lang attribute
const locale = document.documentElement.lang;

export const i18n = new VueI18n({
    messages: { nl, en },
    locale: locale,
    fallbackLocale: 'nl',
    formatter: new LaravelFormatter(locale)
});

Vue.use(datePicker);
Vue.use(VueLazyLoad);
Vue.use(LightBox);
Vue.use(VueNestable);
Vue.use(InlineSvgPlugin);
Vue.use(VueShepherd);

const VueCookie = require('vue-cookie');

Vue.use(CKEditor);

/**
 * First we will load all of this project’s JavaScript dependencies, which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

Vue.use(BootstrapVue);
Vue.use(ReadMore);
Vue.use(VueCookie);
Vue.use(VueMasonry);
Vue.use(VueMoment, { moment });

const tableOptions = {
    debounce: 800,
    texts: {
        count: i18n.t('table.count'),
        first: i18n.t('table.first'),
        last: i18n.t('table.last'),
        filter: i18n.t('table.filter') + ':',
        filter_placeholder: i18n.t('table.filter_placeholder'),
        limit: i18n.t('table.limit') + ':',
        page: i18n.t('table.page') + ':',
        no_results: i18n.t('table.no_results'),
        filter_by: i18n.t('table.filter_by'),
        loading: i18n.t('table.loading'),
        default_option: i18n.t('table.default_option'),
        columns: i18n.t('table.columns')
    }
};

Vue.use(ClientTable, tableOptions);
Vue.use(ServerTable, tableOptions, false, require('./helpers/vuetableBootstrapConfig'));

Vue.use(VCalendar, {
    locale: 'nl-NL'
});

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
Vue.component('downloadExcel', JsonExcel);

moment.locale('nl');

axios.defaults.baseURL = baseUrl;

Vue.prototype.axios = axios;
Vue.prototype.alert = Alert;
Vue.prototype.routes = routes;
Vue.prototype.moment = moment;
Vue.prototype.$orgChart = OrgChart;
Vue.prototype.$tourController = new TourController();
Vue.prototype.common = Common;
Vue.prototype.$groupType = typeof groupType !== 'undefined' ? groupType : null;
Vue.prototype.$authUser = new AuthUser(auth_user);
Vue.prototype.$env = env;

export const CommonBus = new Vue();
export const LogBus = new Vue();
export const SourceBus = new Vue();
export const FilesBus = new Vue();
export const AssignmentBus = new Vue();
export const PortfolioBus = new Vue();
export const RatingBus = new Vue();
export const RoadmapBus = new Vue();
export const QuestionnaireBus = new Vue();
export const ords = new Ords([
    UserModelConfig,

    SchoolModelConfig,
    SchoolTypeModelConfig,

    EducationLevelModelConfig,

    AfaqCategoryModelConfig,
    AfaqQuestionAnswerModelConfig,
    AfaqTagModelConfig,

    InternshipModelConfig,
    InternshipDurationTagModelConfig,
    InternshipTagModelConfig,

    AssignmentModelConfig,
    AssignmentPublishingModelConfig,
    AssignmentDeadlineModelConfig,
    AssignmentStatusModelConfig,
    AssignmentFeedbackModelConfig,
    AssignmentCooperationModelConfig,
    AssignmentPartnerModelConfig,
    AssignmentPartnerUserModelConfig,
    AssignmentStatusLogModelConfig,
    AssignmentStatusActivityModelConfig,
    SubAssignmentStatusActivityModelConfig,

    SubAssignmentModelConfig,
    SubAssignmentDeadlineModelConfig,
    SubAssignmentStatusModelConfig,
    SubAssignmentFeedbackModelConfig,
    AssignmentPageModelConfig,
    SubAssignmentStatusLogModelConfig,

    AssignmentPartModelConfig,
    AssignmentPartTextModelConfig,
    AssignmentPartVideoLinkModelConfig,
    AssignmentPartFileModelConfig,

    AssignmentPartAnswerModelConfig,
    AssignmentPartAnswerTextModelConfig,
    AssignmentPartAnswerJsonModelConfig,
    AssignmentPartAnswerFileModelConfig,
    AssignmentPartAnswerListItemModelConfig,
    AssignmentPartAnswerListCheckModelConfig,

    AssignmentPartListItemModelConfig,
    AssignmentPartListOptionModelConfig,

    PortfolioRatingModelConfig,
    PortfolioRatingResultModelConfig,

    GroupPairGroupTeachersConfig,
    GroupPairGroupsConfig,
    GroupPairStudentsConfig,
    GroupPairGroupCoursesConfig,
    GroupPairTeachersConfig,

    LasStudentModelConfig,

    StudentsModelConfig,
    TeachersModelConfig,
    GroupModelConfig,
    CourseModelConfig,
    LasGroupsModelConfig,
    LasMainGroupsModelConfig,
    LasStudentModelConfig,
    LasGroupsModelConfig,
    LasMainGroupsModelConfig,

    groupsModelConfig,
    projectModelConfig,

    ModuleModelConfig,
    ModuleUserModelConfig,
    ModulePeriodModelConfig,
    PeriodModelConfig,
    ModuleDateModelConfig,
    ModuleTagsModelConfig,
    ModuleModuleTagsModelConfig,
    ModuleTagModelConfig,
    ModuleSkillModelConfig,
    ModuleSkillTreeModelConfig,
    ModuleSchoolEducationLevelModelConfig,
    ModuleTeachersodelConfig,

    FileModelConfig,

    ImageModelConfig,
    LasStudentModelConfig,

    SkillTreeModelConfig,
    SkillModelConfig,
    SkillSkillTreeModelConfig,
    DefaultSkillTreesModelConfig,
    Skill_TreeModelConfig,

    RubricModelConfig,
    RubricAnswerConfig,
    RubricCellConfig,
    RubricColumnConfig,
    RubricFormConfig,
    RubricFormResultConfig,
    RubricOptionConfig,
    RubricRowConfig,
    RubricSectionConfig,
    RubricableSkillLevelYearModelConfig,

    RubricSurveyConfig,
    RubricSurveyUserConfig,
    RubricSurveyUserPeerConfig,

    PersonalGoalsModelConfig,
    PersonalGoalsTaskModelConfig,
    PersonalGoalsBadgeModelConfig,
    PersonalGoalsSkillModelConfig,
    PersonalGoalTaskDeadlineModelConfig,
    PersonalGoalTaskFileModelConfig,

    AgendaItemModelConfig,

    ProfileImageModelConfig,

    RatingModelConfig,
    RatingSectionModelConfig,
    RatingItemModelConfig,
    RatingItemOptionModelConfig,

    QuestionnaireModelConfig,
    QuestionnaireSectionModelConfig,
    QuestionnaireQuestionModelConfig,

    RoadmapModelConfig,
    RoadmapStepModelConfig,
    DeadlineModelConfig,
    RoleModelConfig,

    ProfileCategoryModelConfig,

    CustomFormModelConfig,
    CustomFormPageModelConfig,
    CustomFormQuestionModelConfig,
    CustomFormQuestionOptionModelConfig,

    BadgesModelConfig
]);

// TODO: Update these with locales
Vue.filter('date_time_named_month', (value) => {
    return moment(value).format('DD MMM YYYY, HH:mm');
});

Vue.filter('date_named_month', (value) => {
    return moment(value).format('DD MMM YYYY');
});

Vue.filter('date_named_month_short', (value) => {
    const date = moment(value).format('DD MMM');
    const cleanDate = date.split('.');
    return cleanDate.filter((date) => date.indexOf('.') === -1).join('');
});

Vue.filter('date_time_om', (value) => {
    if (moment(value).format('YYYY') === moment().format('YYYY')) {
        return moment(value).format('DD MMM') + ' om ' + moment(value).format('HH:mm');
    } else {
        return moment(value).format('DD MMM YYYY') + ' om ' + moment(value).format('HH:mm');
    }
});

Vue.filter('date_time_om_year', (value) => {
    return moment(value).format('DD MMM YYYY') + ' om ' + moment(value).format('HH:mm');
});

Vue.filter('date_written', (value) => {
    if (moment(value).format('YYYY') === moment().format('YYYY')) {
        return moment(value).format('DD MMM');
    } else {
        return moment(value).format('DD MMM YYYY');
    }
});

Vue.filter('date_digital', (value) => {
    return moment(value).format('DD-MM-YYYY');
});

Vue.filter('time_hours_minutes', (value) => {
    let month = new Date().getMonth() + 1;

    return moment(month + '-' + new Date().getDate() + '-' + new Date().getFullYear() + ' ' + value).format('HH:mm');
});

Vue.filter('editor_text_preview', (value, maxchar) => {
    const dummyDiv = document.createElement('div');
    dummyDiv.innerHTML = value;
    const contentStripped = dummyDiv.textContent || dummyDiv.innerText || '';
    dummyDiv.remove();

    if (maxchar !== null) {
        return contentStripped.split(' ').length > maxchar
            ? contentStripped.split(' ').splice(0, maxchar).join(' ') + ' ...'
            : contentStripped;
    }

    return contentStripped;
});

Vue.filter('strip_html_tags', (value) => {
    const dummyDiv = document.createElement('div');
    dummyDiv.innerHTML = value;
    const contentStripped = dummyDiv.textContent || dummyDiv.innerText || '';
    dummyDiv.remove();

    return contentStripped;
});

Vue.filter('normalize_string', (value) => {
    if (typeof value === 'string' || value instanceof String) {
        return value
            .toLowerCase()
            .normalize('NFD')
            .replace(/\p{Diacritic}/gu, '');
    }

    return '';
});

Vue.filter('format_number', (value) => {
    return new Intl.NumberFormat('nl-NL').format(value);
});

Vue.filter('validate_email', (email) => {
    const regEx =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regEx.test(email);
});

Vue.filter('validate_zipcode', (zipcode) => {
    const regEx = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
    return regEx.test(zipcode);
});

Vue.filter('validate_belgium_zipcode', (zipcode) => {
    const regEx = /^[1-9][0-9]{3}$/;
    return regEx.test(zipcode);
});

Vue.directive('trim', {
    inserted: (el, binding) => {
        el.innerHTML = el.innerHTML.split(' ').slice(0, binding.value).join(' ');
    }
});

if (['production', 'staging'].includes(process.env.MIX_APP_ENV) && !process.env.MIX_SENTRY_DSN) {
    throw new Error('MIX_SENTRY_DSN is required in production environment');
}

Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN,
    environment: process.env.MIX_APP_ENV,
    release: process.env.MIX_SENTRY_RELEASE,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        Sentry.captureConsoleIntegration({
            // TODO: Add 'warn' back in when we've fixed some high occurrence warnings
            // levels: ['warn', 'error'],
            levels: ['error']
        }),
        Sentry.vueIntegration({
            Vue,
            attachProps: true,
            logErrors: true
        })
    ],
    profilesSampleRate: parseFloat(process.env.MIX_SENTRY_PROFILES_SAMPLE_RATE),
    tracesSampleRate: parseFloat(process.env.MIX_SENTRY_TRACES_SAMPLE_RATE),
    tracePropagationTargets: [
        'localhost',
        /^https:\/\/portal(test)?\.apprenticexm\.nl/,
        /^https:\/\/school-portal\.test/
    ],
    replaysSessionSampleRate: parseFloat(process.env.MIX_SENTRY_REPLAYS_SESSION_SAMPLE_RATE),
    replaysOnErrorSampleRate: 1.0
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./components/', true, /\.vue$/i);
files.keys().map((key) => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const App = new Vue({
    el: '#app',
    i18n
});

App.$moment.locale(locale);

window.Vue = Vue;
